import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/solid";
import React from "react";
import { trackCustomEvent } from "../../utils/analytics";

type PaginationType = {
  offset: number;
  setOffset: (T: number) => void;
  numberOfJobsToCall: number;
  data: {}[];
  tx: Queries.SERPPageQuery["tx"];
};

export default function Pagination({
  offset,
  setOffset,
  numberOfJobsToCall,
  data,
  tx,
}: PaginationType) {
  return (
    <div className="border-t border-gray-200  bg-slate-100 shadow-inner">
      <nav
        className="mx-auto flex max-w-xl justify-end gap-5 px-8 py-8 lg:max-w-3xl"
        aria-label="Pagination"
      >
        {offset > 0 && (
          <button
            onClick={() => {
              window.scrollTo({ top: 0 });
              setOffset(offset - numberOfJobsToCall);
              trackCustomEvent({
                action: "click",
                category: "SERP",
                label: "Previous page",
              });
            }}
            className="flex items-center justify-center gap-2 rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-primary-600 shadow hover:bg-primary-100"
          >
            <ArrowLeftIcon className="h-5 w-5" />
            {tx.previous}
          </button>
        )}
        {data.length > numberOfJobsToCall && (
          <button
            onClick={() => {
              window.scrollTo({ top: 0 });
              setOffset(offset + numberOfJobsToCall);
              trackCustomEvent({
                action: "click",
                category: "SERP",
                label: "Next page",
              });
            }}
            className="flex flex-1 items-center justify-center gap-2 rounded-md border border-transparent bg-primary-600 px-8 py-3 text-base font-medium text-white shadow hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600 sm:px-10"
          >
            {tx.next}
            <ArrowRightIcon className="h-5 w-5 " />
          </button>
        )}
      </nav>
    </div>
  );
}
